import { GridBreakpoints } from '@/components/GridItemCard/FluidItemGrid/FluidItemGrid';

export const gridBreakpointsPast: GridBreakpoints = {
    colsByBreakpoint: {
        base: 1,
        lgMin: 6,
        smMin: 4,
    },
    gapsByBreakpoint: {
        base: { x: 'sm', y: 'lg' },
        lgMin: { x: 'md', y: 'lg' },
        smMin: { x: 'md', y: 'lg' },
    },
};

export const gridBreakpointsUpcoming: GridBreakpoints = {
    colsByBreakpoint: {
        base: 1,
        smMin: 4,
    },
    gapsByBreakpoint: {
        base: { x: 'sm', y: 'lg' },
        smMin: { x: 'md', y: 'lg' },
    },
};
